import ChartPDFParametersFormattingStrategy from './ChartPDFParametersFormattingStrategy'
import ChartPDFDateRangeFormattingStrategy from '../../../../pdf/formatters/ChartPDFDateRangeFormattingStrategy'

export default class ChartPDFOvertimeParametersFormattingStrategy extends ChartPDFParametersFormattingStrategy {
    init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor) {
        super.init(selectorsData, dateFormat, dateFormatForFile, reportAuthorizationInfo, reportParamsStringBuilderConstructor)
        return this
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile) {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters) {
        return {
            firstRow: this.parametersFormatter.formatOvertimeUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection),
            secondRow: ' '
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfgenerator/formatters/ChartPDFOvertimeParametersFormattingStrategy.js